/**
 * Created by Jie Gao on 2019-03-29.
 */
import {
    IStillImageBackgroundConfig,
    StillImageBackground
} from "@nolimitcity/slot-game/bin/game/background/StillImageBackground";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {GGGameConfig} from "../GGGameConfig";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {GameMode, IGameModeChangedData} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {Power3, TimelineLite, TweenLite, TimelineMax} from "gsap";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {GGGameAssets} from "../GGGameAssets";
import {GGGameMode} from "../gamemode/GGGameMode";
import {AnimationEffects} from "../effects/AnimationEffects";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {BalanceEvent} from "@nolimitcity/slot-game/bin/core/balance/event/BalanceEvent";
//import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
//import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
//import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
//import {StageEvent} from "@nolimitcity/slot-game/bin/core/stage/event/StageEvent";

export class GGBackground extends StillImageBackground {
    private static coinShinePos: [number, number][] = [[-231, 461], [-120, 542], [811, 455], [729, 582], [760, 411], [475, 705], [116, 701], [67, 901], [538, 904]];
    private static portraitLogoSign: string[] = ["portraitLogoSign", "portraitLogoSign_FS"];
    private _reelBackground: PIXI.Sprite;
    private _reelBgLayer: PIXI.Container;
    private _fsAnimationLayer: PIXI.Container;
    private _logoPortrait: PIXI.Sprite;
    private _torchEmptyL: PIXI.Sprite;
    private _torchEmptyR: PIXI.Sprite;
    private _torchFireL: PIXI.spine.Spine;
    private _torchFireR: PIXI.spine.Spine;
    private _bgNearwinShine: PIXI.spine.Spine;
    private _fsCart: PIXI.spine.Spine;
    private _fsElement: PIXI.spine.Spine;
    private _fsButcher: PIXI.spine.Spine;
    private _fsParticles: PIXI.spine.Spine;
    private _coinShineTimeline: TimelineLite;

    private _isLandscape: boolean;
    private _fsTimeline: TimelineLite | null;

    //private _blowMyGame: TimelineMax;
    private _toDelResizeData: IResizeData;

    private _fsBgPanDownEffect: PIXI.Sprite;

    constructor(config: IStillImageBackgroundConfig) {
        super(config);
        this._fsAnimationLayer = StageManager.getLayer(GGGameConfig.instance.LAYERS.FS_ANIMATION.name);
        this._fsAnimationLayer.visible = false;
    }

    protected addEventListeners():void {
        super.addEventListeners();
        EventHandler.addEventListener(this, BalanceEvent.ZERO_BET, (event:GameEvent) => this.onZeroBet(event.params[0]));
    }
    private onZeroBet(fsLeft?:number):void {
        if(fsLeft == undefined){
            return;
        }

        if(this._fsAnimationLayer.visible){
            const tl:TimelineLite = new TimelineLite();
             tl.add(()=>this._fsButcher.state.setAnimation(0, "animation", false));
             tl.add(()=>this._fsButcher.state.setAnimation(0, "Idle", true), 1);
        }

    }
    public playNearWin(): void {
        if (!this._bgNearwinShine) {
            const spineAnimation: PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset("BG_Shine"));
            spineAnimation.pivot.set(0.5, 0.5);
            spineAnimation.name = "BG_Shine";
            spineAnimation.position.set(360, 360);
            StageManager.getLayer(GGGameConfig.instance.LAYERS.NEARWIN_GLOW.name).addChild(spineAnimation);
            this._bgNearwinShine = spineAnimation;
        }
        this._bgNearwinShine.renderable = true;
        this._bgNearwinShine.visible = true;
        this._bgNearwinShine.state.setAnimation(0, "Anticipation_S_W", true);
    }

    public stopNearWin(): void {
        this._bgNearwinShine.renderable = false;
        this._bgNearwinShine.visible = false;
    }

    public bombExplode(): void {
        const isFS:boolean = this._fsAnimationLayer.visible;
        AnimationEffects.Shake({
            obj:StageManager.stage,
            duration: 1.7,
            hertz:isFS?240:120,
            x:1,
            y:1,
            Intensity:isFS?15:5,
            positionCb: () => new PIXI.Point(0,0),
            ease: Power3.easeOut,
            reverseEase:true
        })
    }

    // #403
    public panUpDownEffect(down: boolean, isRestore: boolean): TweenLite[] {
        if (isRestore) {
            return [];
        }
        const twArr: TweenLite[] = [];

        if (down) {
            this.moveItems(twArr, [258 - 1680, 258], [217 - 1680, 217], [360 - 1680, 360], [360, 360 + 1680], [0, 1680]);

            twArr[0].eventCallback("onStart", () => {
                // keep it here too, because of restore.
                this._fsBgPanDownEffect.visible = true;
                this._backgroundSprite.texture = GameResources.getTextures(this._backgroundImages[GameMode.NORMAL].image)[0];

                this.toggleTorches(true);

                this._logoPortrait.texture = GameResources.getTextures(GGBackground.portraitLogoSign[0])[0];
            });
            twArr[0].eventCallback("onComplete", () => {
                this._fsBgPanDownEffect.visible = false;

                this.removeFSBackgroundAnimation();
            });
        } else {
            this.moveItems(twArr, [258, 258 - 1680], [217, 217 - 1680], [360, 360 - 1680], [360 + 1680, 360], [1680, 0]);

            twArr[0].eventCallback("onStart", () => {
                this._fsBgPanDownEffect.visible = true;
                this.showFSBackground();

                this._logoPortrait.texture = GameResources.getTextures(GGBackground.portraitLogoSign[1])[0];
            });
            twArr[0].eventCallback("onComplete", () => this.toggleTorches(false));
        }

        return twArr;
    }

    protected initAnimations(): void {
        super.initAnimations();
        const top: number = GGGameConfig.instance.REEL_AREA_TOP + GGGameConfig.instance.REEL_AREA_POS_Y + 30;
        this._reelBgLayer = StageManager.getLayer(GGGameConfig.instance.LAYERS.REEL_BACKGROUND.name);

        this._torchEmptyL = this.createSprite("torchEmpty", 0.5, [-125, 258]);
        this._reelBgLayer.addChild(this._torchEmptyL);

        this._torchEmptyR = this.createSprite("torchEmpty", 0.5, [824, 258]);
        this._reelBgLayer.addChild(this._torchEmptyR);

        this._torchFireL = this.createSpine("BG_Fire", [-124, 217]);
        this._torchFireR = this.createSpine("BG_Fire", [824, 217]);

        this._logoPortrait = this.createSprite("portraitLogoSign", 1, [386, top + 90]);
        this._logoPortrait.name = "portraitLogoSign";
        this._reelBgLayer.addChild(this._logoPortrait);

        this._coinShineTimeline = this.creatCoinShineTimeline();

        this._reelBackground = this.createSprite("reelBackground", 0.5, [360, 402]);
        this._reelBgLayer.addChild(this._reelBackground);

        const foregroundLayer: PIXI.Container = StageManager.getLayer(GGGameConfig.instance.LAYERS.REEL_FOREGROUND.name);

        this.createReelFrame(foregroundLayer);

        this._backgroundSprite.anchor.set(0.5, 0.5);
        this._backgroundSprite.x = 360;
        this._backgroundSprite.y = 360;

        this._fsBgPanDownEffect = this.addChild(this.createSprite(GGGameAssets.FS_GAME_BACKGROUND, 0.5, [360, 360]));
        this._fsBgPanDownEffect.visible = false;
    }

    protected onResize(resizeData: IResizeData): void {
        // remove
        //this._toDelResizeData = resizeData;

        const isLandscape: boolean = (resizeData.orientation === Orientation.LANDSCAPE);
        this._isLandscape = isLandscape;
        if (!this._fsAnimationLayer.visible) {
            this._torchFireL.visible = isLandscape;
            this._torchFireR.visible = isLandscape;
        }
        if (resizeData.orientation !== Orientation.PORTRAIT) {
            this._logoPortrait.visible = false;
            return;
        }

        this._logoPortrait.visible = true;
        const topSpace = (NolimitApplication.screenBounds.height - 720) * 0.5;
        if (topSpace >= 190) {
            this._logoPortrait.scale.set(1);
            this._logoPortrait.position.set(386, 268);
            return;
        }

        this._logoPortrait.visible = false;
    }

    protected onChangeBackground(data: IGameModeChangedData): boolean {
        if (data.newMode === this._currentMode) {
            return false;
        }

        this._currentMode = data.newMode;

        this._backgroundSprite.texture = GameResources.getTextures(this._backgroundImages[this._currentMode].image)[0];

        if (this._currentMode === GameMode.FREESPIN || this._currentMode === GameMode.FREESPIN_AVALANCHE || this._currentMode === GGGameMode.FREESPIN_SUPER) {
            this.showFSBackground();

            this._logoPortrait.texture = GameResources.getTextures(GGBackground.portraitLogoSign[1])[0];
            this.toggleTorches(false);
        }

        return true;
    }

    private createSpine(name: string, pos: [number, number], init: boolean = true): PIXI.spine.Spine {
        const spineAnimation: PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset(name));
        spineAnimation.pivot.set(0.5, 0.5);
        spineAnimation.name = name;
        spineAnimation.position.set(pos[0], pos[1]);
        spineAnimation.renderable = init;
        spineAnimation.visible = init;
        if (init) {
            spineAnimation.state.setAnimation(0, "Idle", true);
        }
        this._reelBgLayer.addChild(spineAnimation);
        return spineAnimation;
    }

    private createSprite(name: string, anchorY: number, pos: [number, number]): PIXI.Sprite {
        const sprite: PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures(name)[0]);
        sprite.name = name;
        sprite.anchor.set(0.5, anchorY);
        sprite.position.set(pos[0], pos[1]);
        return sprite;
    }

    private createReelFrame(foregroundLayer: PIXI.Container): void {
        const frameL: PIXI.Sprite = this.createSprite("reelFrameL", 0.5, [-27, 410]);
        const frameR: PIXI.Sprite = this.createSprite("reelFrameR", 0.5, [748, 410]);
        const frameT: PIXI.Sprite = this.createSprite("reelFrameT", 0.5, [360, 101]);
        const frameB: PIXI.Sprite = this.createSprite("reelFrameB", 0.5, [360, 704]);
        foregroundLayer.addChild(frameT);
        this._reelBgLayer.addChild(frameL);
        this._reelBgLayer.addChild(frameR);
        this._reelBgLayer.addChild(frameB);
    }

    private createFreespinBackground(): void {
        if (!this._fsCart) {
            const bone: PIXI.Sprite = this.createSprite("fsBGBone", 0.5, [100, -283]);
            this._fsAnimationLayer.addChild(bone);
            this._fsCart = new PIXI.spine.Spine(GameResources.getSpineAsset("FS_Cart"));
            this._fsCart.pivot.set(0.5, 0.5);
            this._fsCart.name = "cartAnimation";
            this._fsCart.position.set(360, 360);
            this._fsAnimationLayer.addChild(this._fsCart);

            this._fsElement = new PIXI.spine.Spine(GameResources.getSpineAsset("FS_Elements"));
            this._fsElement.pivot.set(0.5, 0.5);
            this._fsElement.name = "fsElement";
            this._fsElement.position.set(360, 360);
            this._fsAnimationLayer.addChild(this._fsElement);

            const bridge: PIXI.Sprite = this.createSprite("fsBGBridge", 0.5, [360, 459]);
            this._fsAnimationLayer.addChild(bridge);

            this._fsButcher = new PIXI.spine.Spine(GameResources.getSpineAsset("FS_Goblin"));
            this._fsButcher.pivot.set(0.5, 0.5);
            this._fsButcher.name = "fsButcher";
            this._fsButcher.position.set(360, 360);
            this._fsAnimationLayer.addChild(this._fsButcher);

            this._fsParticles = new PIXI.spine.Spine(GameResources.getSpineAsset("Fs_Particles_well"));
            this._fsParticles.pivot.set(0.5, 0.5);
            this._fsParticles.name = "fsParticles";
            this._fsParticles.position.set(360, 532);
            this._fsAnimationLayer.addChild(this._fsParticles);

            const gold: PIXI.Sprite = this.createSprite("fsBGGolds", 0.5, [360, 592]);
            this._fsAnimationLayer.addChild(gold);

            const top: PIXI.Sprite = this.createSprite("fsBGTop", 0.5, [362, 0]);
            this._fsAnimationLayer.addChild(top);
        }
    }

    private showFSBackground(): void {
        this.createFreespinBackground();
        this._fsAnimationLayer.visible = true;
        this._fsElement.state.setAnimation(0, "animation", true);
        this._fsParticles.state.setAnimation(0, "animation", true);
        this._fsButcher.state.setAnimation(0, "Idle", true);
        this._fsElement.renderable = true;
        this._fsParticles.renderable = true;
        this._fsButcher.renderable = true;
        this._fsElement.visible = true;
        this._fsParticles.visible = true;
        this._fsButcher.visible = true;
        this._fsCart.renderable = true;
        this._fsCart.visible = true;
        this.startCartAnimation();
    }

    private removeFSBackgroundAnimation(): void {
        if (this._fsTimeline) {
            if (this._fsTimeline.isActive()) {
                this._fsTimeline.pause();
            }
            this._fsTimeline = null;
        }
        if (this._fsCart) {
            this._fsCart.renderable = false;
            this._fsElement.renderable = false;
            this._fsParticles.renderable = false;
            this._fsCart.visible = false;
            this._fsElement.visible = false;
            this._fsParticles.visible = false;
            this._fsButcher.visible = false;
        }
        this._fsAnimationLayer.visible = false;
    }

    private creatCoinShineTimeline(): TimelineLite {
        const tl: TimelineLite = new TimelineLite({
            onComplete:  () => {
                tl.restart();
            }
        });
        const coinShine: PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("coinShine")[0]);
        coinShine.blendMode = PIXI.BLEND_MODES.ADD;
        coinShine.name = "coinShine";
        coinShine.alpha = 0;
        this._reelBgLayer.addChild(coinShine);

        tl.add([() => {
            const pos: [number, number] = GGBackground.coinShinePos[Math.floor(Math.random() * GGBackground.coinShinePos.length)]
            coinShine.position.set(pos[0], pos[1]);
        },
            TweenLite.fromTo(coinShine, 0.15, {alpha: 0}, {alpha: 0.35}),
            TweenLite.to(coinShine, 0.3, {alpha: 0, delay: 0.6})
        ], 10 * Math.random());
        return tl;
    }

    private startCartAnimation(): void {
        this._fsTimeline = new TimelineLite({
            onComplete: () => {
                if (this._fsCart.visible) {
                    this.startCartAnimation();
                }
            }
        });
        const startTime: number = Math.random() * 10;
        this._fsTimeline.add(() => {
            this._fsCart.state.setAnimation(0, "animation", false);
        }, startTime);
        // this._fsTimeline.add(() => {this._fsButcher.state.setAnimation(0, "animation", true);}, startTime + 1);
        this._fsTimeline.add(() => {
        }, startTime + 5);
        //this.boomGame();
    }

    private moveItems(twArr: TweenLite[], emptyTorchY: number[], fireY: number[], mainBgY: number[], fsBgPanY: number[], fsElementsY: number[]): void {
        const moveDuration: number = 1.5;

        twArr.push(TweenLite.fromTo([this._torchEmptyL.position, this._torchEmptyR.position], moveDuration, {y: emptyTorchY[0]}, {
            y: emptyTorchY[1],
            ease: Power3.easeOut
        }));

        twArr.push(TweenLite.fromTo([this._torchFireL.position, this._torchFireR.position], moveDuration, {y: fireY[0]}, {
            y: fireY[1],
            ease: Power3.easeOut
        }));

        twArr.push(TweenLite.fromTo(this._backgroundSprite.position, moveDuration, {y: mainBgY[0]}, {
            y: mainBgY[1],
            ease: Power3.easeOut
        }));

        twArr.push(TweenLite.fromTo(this._fsBgPanDownEffect.position, moveDuration, {y: fsBgPanY[0]}, {
            y: fsBgPanY[1],
            ease: Power3.easeOut
        }));

        twArr.push(TweenLite.fromTo(this._fsAnimationLayer.position, moveDuration, {y: fsElementsY[0]}, {
            y: fsElementsY[1],
            ease: Power3.easeOut
        }));
    }

    private toggleTorches(visible: boolean): void {
        this._torchEmptyL.visible = visible;
        this._torchEmptyR.visible = visible;

        this._torchFireR.renderable = visible;
        this._torchFireL.renderable = visible;
        this._torchFireR.visible = visible;
        this._torchFireL.visible = visible;
    }

   //public boomGame():void{
   //        this._blowMyGame = new TimelineMax({
   //            repeat:-1,
   //            repeatDelay:0,
   //            onRepeat:() =>{
   //                EventHandler.dispatchEvent(new GameEvent(SpinEvent.WANT_SKIPPABLE));
   //                EventHandler.dispatchEvent(new GameEvent(SpinEvent.SKIP));
   //                if(this._resizeData)
   //                    EventHandler.dispatchEvent(new GameEvent(StageEvent.STAGE_RESIZED, this._toDelResizeData));
   //                // if(PunkEngineManager.isPlaying) EventHandler.dispatchEvent(new GameEvent(SpinEvent.STOP));
   //            }
   //        })
   //        this._blowMyGame.to(this,0.01,{});
   //        this._blowMyGame.play();
    //}
}